module.exports = __webpack_public_path__ + "static/banner-52a06d0a5cc01e99f8f9498836555fa8.png";